"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Icon_1 = __importDefault(require("../../Icon/Icon"));
const toasts_1 = require("../../Notifications/Toasts/toasts");
const CopyToClipboard = (props) => {
    const { textToCopy, successToastText, errorToastText, children, className, iconColor = 'blue', onlyShowIconOnHover = false, onCopySuccess, } = props;
    const { addToast } = toasts_1.useToasts();
    const handleCopy = () => {
        navigator.clipboard.writeText(textToCopy).then(copySucceeded, copyFailed);
    };
    const copySucceeded = () => {
        if (successToastText) {
            addToast({ type: 'success', body: successToastText, autoDismiss: true });
        }
        if (onCopySuccess) {
            onCopySuccess();
        }
    };
    const copyFailed = () => {
        if (errorToastText) {
            addToast({ type: 'error', body: errorToastText, autoDismiss: true });
        }
    };
    const iconClassNames = classnames_1.default('clipboard-icon', {
        [`clipboard-icon-on-hover`]: !!children && onlyShowIconOnHover,
    });
    return (React.createElement("div", { className: classnames_1.default('copy-to-clipboard-container', className) },
        children,
        React.createElement(Icon_1.default, { className: iconClassNames, icon: `copy_to_clipboard_${iconColor}`, onClick: handleCopy })));
};
exports.default = CopyToClipboard;
//# sourceMappingURL=CopyToClipboard.js.map